import * as React from 'react';
import { cn } from '../../../utils/ClassNamesUtils';
import { OSCAR_MARK_SIZE } from '../../constants/AIAgentConstants';
import OscarMark from '../shared/OscarMark';
import { useOscarTheme } from '../../context/OscarRoleContext';

interface OscarLauncherPillProps {
	label?: string;
	onClick?: () => void;
	className?: string;
}

/**
 * Entry point that opens the Oscar panel.
 *
 * Figma node 14998:125400 — purple/3 fill, square corners, 12px horizontal
 * padding, 4px gap, 32px mark, Body/medium label in surface/brand. Height is 40px
 * (h-10) to match the app top bar it sits in — Figma's frame says 41px.
 */
export const OscarLauncherPill = ({
	label = 'Oscar',
	onClick,
	className,
}: OscarLauncherPillProps) => {
	const theme = useOscarTheme();
	return (
		<button
			type="button"
			onClick={onClick}
			className={cn(
				'flex h-10 cursor-pointer items-center justify-center gap-2xs border-none px-s py-2xs transition-colors',
				theme.accentFill,
				className
			)}
		>
			<OscarMark size={OSCAR_MARK_SIZE.launcher} />
			<span className={cn('bodymedium whitespace-nowrap text-center', theme.accentText)}>
				{label}
			</span>
		</button>
	);
};

export default OscarLauncherPill;
